import { Link } from "gatsby"
import React from 'react'
import Brithday from '../assets/Brithday.png'


const Projetos = ({ children }) => {
    return (
        <div> 
                           
                <div className='py-4 px-5 w-full sm:flex space-x-5 space-y-5 color-al-4'>
                    <p></p>  
                    <div className=' py-4 px-2  max-w-sm bg-gray-300 shadow-md      rounded'>
						<div className="px-3 text-center animation-ronsof-one font-bold  text-xl mb-2">
                             <h2>
                             <p className='px-4 flex'>Kit 1<img className='px-1 w-20' src={Brithday} alt='Brinday' /></p>
                            </h2>
                            <h3 className='font-al-7 text-center'>
                                <p className="">1 KG de Bolo</p>
                                <p className="">50 Salgados</p>
                                <p className="">25 Doces</p>
                                <p className="">R$ 70,00</p>
                            </h3>
                            <Link className="btn-ronsof-one-green">
                                <a href='http://api.whatsapp.com/send?1=pt_BR&phone=5511954209626'>Peça Aqui
                                </a>
                            </Link>
                        </div> 
                          
					</div>
                    <div className=' py-4 px-2  max-w-sm bg-gray-300  shadow-md     rounded'>
						<div className="px-3 text-center animation-ronsof-one font-bold  text-xl mb-2">
                            <h2>
                                <p className='px-4 flex'>Kit 2<img className='px-1 w-20' src={Brithday} alt='Brinday' /></p>
                            </h2>
                            <h3 className='font-al-7 text-center'>
                                <p className="">2 KG de Bolo</p>
                                <p className="">60 Salgados</p>
                                <p className="">40 Doces</p>
                                <p className="">R$ 112,00</p>
                            </h3>
                            <Link className="btn-ronsof-one-green">
                                <a href='http://api.whatsapp.com/send?1=pt_BR&phone=5511954209626'>Peça Aqui
                                </a>
                            </Link>
                        </div> 
                    </div>
                    <div className=' py-4 px-2  max-w-sm bg-gray-300  shadow-md     rounded'>
						<div className="px-3 text-center animation-ronsof-one font-bold  text-xl mb-2">
                            <h2>
                            <p className='px-4 flex'>Kit 3<img className='px-1 w-20' src={Brithday} alt='Brinday' /></p>
                            </h2>
                            <h3 className='font-al-7 text-center'>
                                <p className="">3 KG de Bolo</p>
                                <p className="">130 Salgados</p>
                                <p className="">70 Doces</p>
                                <p className="">R$ 186,00</p>
                            </h3>
                            <Link className="btn-ronsof-one-green">
                                <a href='http://api.whatsapp.com/send?1=pt_BR&phone=5511954209626'>Peça Aqui
                                </a>
                            </Link>
                        </div> 
                    </div>
                    <div className=' py-4 px-2  max-w-sm bg-gray-300  shadow-md     rounded'>
						<div className="px-3  text-center animation-ronsof-one font-bold  text-xl mb-2">
                            <h2>
                            <p className='px-4 flex'>Kit 4<img className='px-1 w-20' src={Brithday} alt='Brinday' /></p>
                            </h2>
                            <h3 className='font-al-7 text-center'>
                                <p className="">4 KG de Bolo</p>
                                <p className="">200 Salgados</p>
                                <p className="">100 Doces</p>
                                <p className="">R$ 260,00</p>
                            </h3>
                            <Link className="btn-ronsof-one-green">
                                <a href='http://api.whatsapp.com/send?1=pt_BR&phone=5511954209626'>Peça Aqui
                                </a>
                            </Link>
                        </div> 
                    </div>
                    
                </div>     
                    
                {/*<div className='flex-wrap justify-center mx-5 lg:mx-16'>
                    <div className='flex flex-wrap sm:flex-wrap justify-center items-center'>
                        <h1 className='font-ronsof-seven-p1 text-center color-ronsof-four pt-20 lg:mx-56'>
                            Solicite agora mesmo um orçamento sem compromisso!
                        </h1>
                        {children}
                    </div>
                    <div className='flex flex-wrap sm:flex-wrap justify-center items-center pt-10'>
                        <Link to={`/pagecontato`} className="btn-ronsof-one-green-sb shadow-lg">
                            Orçar agora
                        </Link>
                    </div>
                </div>*/}
            
        </div>
    )
}
export default Projetos